import React from 'react';
import PropTypes from 'prop-types';

// Components
import { IconCheckmarkCircleFilled, IconExclamationCircleFilled } from '@zillow/constellation-icons';
import { Box, Button, Card, Icon, Paragraph } from '@zillow/constellation-10';

import MESSAGE_MODULE_TYPES from '../../MESSAGE_MODULE_TYPES';

const propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  ctaPrimaryButton: PropTypes.shape({
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
  ctaSecondaryButton: PropTypes.shape({
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
  closeMessageModule: PropTypes.func.isRequired,
  dismissibleActionId: PropTypes.string,
};

const defaultProps = {
  ctaPrimaryButton: null,
  ctaSecondaryButton: null,
  dismissibleActionId: null,
};

const PaymentsMessageModule = ({
  title,
  description,
  ctaPrimaryButton,
  ctaSecondaryButton,
  type,
  closeMessageModule,
  dismissibleActionId,
}) => {
  if (type === MESSAGE_MODULE_TYPES.CONFIRMATION) {
    return (
      <Card
        elevated={false}
        data-testid="confirmation-payments-message-card"
        css={{ backgroundColor: 'bg.accent.green.soft', marginBottom: '200', borderRadius: 'obj.sharp' }}
      >
        <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
          <Paragraph textStyle="body-bold">{title}</Paragraph>
          <Icon
            render={<IconCheckmarkCircleFilled />}
            size="md"
            css={{ color: 'icon.onImpact.feedback.success.hero' }}
          />
        </Box>
        <Paragraph textStyle="body-sm" css={{ paddingTop: '400', paddingBottom: '600' }}>
          {description}
        </Paragraph>
        {ctaPrimaryButton && ctaPrimaryButton.text && ctaPrimaryButton.url && (
          <Button
            asChild
            tone="brand"
            emphasis="filled"
            size="sm"
            fluid={true}
            data-test="confirmation-payments-card-primary-cta"
            textStyle="body-sm-bold"
            css={{ whiteSpace: 'nowrap' }}
          >
            <a href={ctaPrimaryButton.url}>{ctaPrimaryButton.text}</a>
          </Button>
        )}
        {ctaSecondaryButton && ctaSecondaryButton.text && ctaSecondaryButton.url && (
          <Button
            asChild
            tone="brand"
            emphasis="outlined"
            size="sm"
            fluid={true}
            data-test="confirmation-payments-card-secondary-cta"
            textStyle="body-sm-bold"
            css={{ marginTop: '200', whiteSpace: 'nowrap' }}
          >
            <a href={ctaSecondaryButton.url}>{ctaSecondaryButton.text}</a>
          </Button>
        )}
      </Card>
    );
  }

  if (type === MESSAGE_MODULE_TYPES.DISMISSIBLE_CONFIRMATION) {
    return (
      <Card
        elevated={false}
        data-testid="dismissible-confirmation-payments-message-card"
        css={{ backgroundColor: 'bg.accent.green.soft', marginBottom: '200' }}
      >
        <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
          <Paragraph textStyle="body-bold">{title}</Paragraph>
          <Icon
            render={<IconCheckmarkCircleFilled />}
            size="md"
            css={{ color: 'icon.onImpact.feedback.success.hero' }}
          />
        </Box>
        <Paragraph textStyle="body-sm" css={{ paddingTop: '400', paddingBottom: '600' }}>
          {description}
        </Paragraph>
        {ctaPrimaryButton && ctaPrimaryButton.text && (
          <Button
            tone="brand"
            emphasis="filled"
            size="sm"
            fluid={true}
            data-test="dismissible-confirmation-payments-card-primary-cta"
            onClick={() => closeMessageModule(dismissibleActionId)}
            textStyle="body-sm-bold"
            css={{ whiteSpace: 'nowrap' }}
          >
            {ctaPrimaryButton.text}
          </Button>
        )}
        {ctaSecondaryButton && ctaSecondaryButton.text && ctaSecondaryButton.url && (
          <Button
            asChild
            tone="brand"
            emphasis="outlined"
            size="sm"
            fluid={true}
            data-test="dismissible-confirmation-payments-card-secondary-cta"
            textStyle="body-sm-bold"
            css={{ marginTop: '200', whiteSpace: 'nowrap' }}
          >
            <a href={ctaSecondaryButton.url}>{ctaSecondaryButton.text}</a>
          </Button>
        )}
      </Card>
    );
  }
  if (type === MESSAGE_MODULE_TYPES.WARNING) {
    return (
      <Card
        elevated={false}
        data-testid="warning-payments-message-card"
        css={{ backgroundColor: 'bg.accent.red.soft', marginBottom: '200' }}
      >
        <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
          <Paragraph textStyle="body-bold">{title}</Paragraph>
          <Icon render={<IconExclamationCircleFilled />} size="md" />
        </Box>
        <Paragraph textStyle="body-sm" css={{ paddingTop: '400', paddingBottom: '600' }}>
          {description}
        </Paragraph>
        {ctaPrimaryButton && ctaPrimaryButton.text && ctaPrimaryButton.url && (
          <Button
            asChild
            tone="brand"
            emphasis="filled"
            size="sm"
            fluid={true}
            data-test="warning-payments-card-primary-cta"
            textStyle="body-sm-bold"
            css={{ whiteSpace: 'nowrap' }}
          >
            <a href={ctaPrimaryButton.url}>{ctaPrimaryButton.text}</a>
          </Button>
        )}
        {ctaSecondaryButton && ctaSecondaryButton.text && ctaSecondaryButton.url && (
          <Button
            asChild
            tone="brand"
            emphasis="outlined"
            size="sm"
            fluid={true}
            data-test="warning-payments-card-secondary-cta"
            textStyle="body-sm-bold"
            css={{ marginTop: '200', whiteSpace: 'nowrap' }}
          >
            <a href={ctaSecondaryButton.url}>{ctaSecondaryButton.text}</a>
          </Button>
        )}
      </Card>
    );
  }

  return null;
};

PaymentsMessageModule.propTypes = propTypes;
PaymentsMessageModule.defaultProps = defaultProps;

export default PaymentsMessageModule;
